import React, { useEffect, useRef } from "react";
var useDatePickerFocusManager = function(finalIsOpen, handleDismiss) {
    var canReturnFocusRef = useRef(false);
    useEffect(function() {
        var handleEscapeKey = function(e) {
            if (e.key === 'Escape') {
                if (finalIsOpen) {
                    e.preventDefault();
                    canReturnFocusRef.current = true;
                    handleDismiss();
                }
            }
        };
        if (document && finalIsOpen) {
            document.addEventListener('keydown', handleEscapeKey);
            return function() {
                document.removeEventListener('keydown', handleEscapeKey);
            };
        }
    }, [
        finalIsOpen,
        handleDismiss
    ]);
    var handleCanReturnFocus = function() {
        if (canReturnFocusRef.current) {
            return Promise.resolve();
        }
        return new Promise(function() {});
    };
    var setCanReturnFocusRef = function(newValue) {
        if (newValue) {
            canReturnFocusRef.current = true;
        } else {
            canReturnFocusRef.current = false;
        }
    };
    return {
        handleCanReturnFocus: handleCanReturnFocus,
        setCanReturnFocusRef: setCanReturnFocusRef
    };
};
export default useDatePickerFocusManager;
